import type { OrganizationResponse } from "@models/organization";
import { RoleType } from "@models/user";

// Whether this user holds the organization's Admin role, the only role the API
// lets save a card (#445 Q7; CreatePaymentMethod requires it, a Contributor gets
// 403). organizations/me `roles[].role` is the API's RoleType, the same enum
// RoleType in @models/user mirrors (Admin 1, Contributor 2). OrganizationUserRole
// in @models/organization labels the same integers Owner/Member; it is not used
// here.
export const isOrganizationAdmin = (
    organization: OrganizationResponse | undefined,
    userId: string,
): boolean =>
    !!organization?.roles.some(
        (role) => role.userId === userId && role.role === RoleType.Admin,
    );
